import styled from "@emotion/styled";
import { NavTitle as F7NavTitle } from "framework7-react";

export const NavTitle = styled(F7NavTitle)`
  text-align: center !important;
  width: 100%;
`;
